<template>
  <div class="layout-root">
    <!-- 左侧导航栏 -->
    <div class="sidebar-container">
      <div class="sidebar-inner">
        <div class="sidebar-header">
          <img src="@/assets/logo.png" alt="Logo" class="sidebar-logo" />
        </div>
        <nav class="custom-menu">
          <div
            v-for="item in menuList"
            :key="item.index"
            :class="['custom-menu-item', { active: activeMenu === item.index }]"
            @click="handleMenuSelect(item.index)"
          >
            <span class="icon-text-group">
              <SidebarMenuIcon :icon="item.icon" :activeIcon="item.activeIcon" :active="activeMenu === item.index" />
              <span>{{ item.label }}</span>
            </span>
            <SidebarStar :active="activeMenu === item.index" />
          </div>
        </nav>
      </div>
    </div>
    <!-- 右侧主内容区 -->
    <div class="main-content">
      <header class="header">
        <div class="user-info">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="color: #fff; margin-right: 20px; cursor: pointer;">
              <i class="el-icon-user user-icon" style="color: #fff;"></i> {{ userName }}&nbsp;<strong>同学！</strong>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile" to="/profile">个人资料</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>
      <!-- 右侧内容区域，根据路由显示对应组件 -->
      <div class="content">
        <Dashboard v-if="activeComponent === 'dashboard'" />
        <Profile v-else-if="activeComponent === 'profile'" />
        <Diagram v-else-if="activeComponent === 'diagram'" />
        <Tasks v-else-if="activeComponent === 'tasks'" />
        <Membership v-else-if="activeComponent === 'membership'" />
      </div>
    </div>
  </div>
</template>

<script>
// 导入组件
import Dashboard from '@/views/Dashboard.vue';
import Profile from '@/views/Profile.vue';
import Diagram from '@/views/Diagram.vue';
import Tasks from '@/views/Tasks.vue';
import Membership from '@/views/Membership.vue';
import  {EventBus}  from '@/event-bus.js'; 
import axios from 'axios';
import SidebarStar from './SidebarStar.vue';
import SidebarMenuIcon from './SidebarMenuIcon.vue';

export default {
  name: 'Index',
  components: { Dashboard, Profile, Diagram, Tasks, Membership, SidebarStar, SidebarMenuIcon },
  data() {
    return {
      activeComponent: '',
      userName: '',
      menuList: [
        { index: '/diagram', label: '创建制图', icon: 'menu-draw.png', activeIcon: 'menu-drawing-active.png' },
        { index: '/dashboard', label: '课程学习', icon: 'courses.png', activeIcon: 'course-active.png' },
        { index: '/tasks', label: '提交作业', icon: 'updates.png', activeIcon: 'update-active.png' },
        { index: '/profile', label: '个人中心', icon: 'im.png', activeIcon: 'im-active.png' },
        { index: '/membership', label: '学习中心', icon: 'percents.png', activeIcon: 'percent-active.png' },
      ],
    };
  },
  computed: {
    activeMenu() {
      return this.$route.path;
    }
  },
  watch: {
    $route(to) {
      this.updateActiveComponent(to.path);
    }
  },
  created() {
    this.updateActiveComponent(this.$route.path);
    this.fetchUserName();
    EventBus.$on('refreshUserName', this.fetchUserName);
  },
  beforeDestroy() {
    EventBus.$off('refreshUserName', this.fetchUserName);
  },
  methods: {
    fetchUserName() {
      // userInfo 直接作为账号使用，去除空格和引号
      let userInfo = localStorage.getItem('userInfo');
      console.log('userInfo原始值:', userInfo);
      let accountNumber = '';
      if (userInfo) {
        accountNumber = userInfo.replace(/\s+/g, '').replace(/^"|"$/g, '');
        // 去除字符串首尾的英文双引号
        console.log('账号:', accountNumber);
      }
      if (!accountNumber) return;
      // 调用新接口获取用户名
      axios.get(`api/auth/selectByAccountNumber?accountNumber=${accountNumber}`)
        .then(res => {
          this.userName = res.data.data.userName || '';
          console.log('用户名:', this.userName);
        });
    },
    handleMenuSelect(key) {
      if (this.$route.path !== key) {
        this.$router.push(key);
      }
      this.updateActiveComponent(key);
    },
    updateActiveComponent(path) {
      if (path === '/dashboard') this.activeComponent = 'dashboard';
      else if (path === '/profile') this.activeComponent = 'profile';
      else if (path === '/diagram') this.activeComponent = 'diagram';
      else if (path === '/tasks') this.activeComponent = 'tasks';
      else if (path === '/membership') this.activeComponent = 'membership';
      else this.activeComponent = '';
    },
    handleCommand(command) {
      if (command === 'logout') {
        axios.post('/api/user/logout').then(() => {
          this.$router.push('/login');
        });
      } else if (command === 'profile') {
        this.$router.push('/profile');
      }
    }
  }
};
</script>

<style scoped>
.layout-root {
  display: flex;
  height: 100vh;
}
.sidebar-container {
  width: 283px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #2EA2FA url('/image/sidebar-bg.png') no-repeat center center;
  background-size: cover;
}
.sidebar-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.sidebar-header {
  background: transparent !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px 0 0;
}
.custom-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 0;
}
.custom-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  width: 90%;
  height: 80px;
  margin-top: 20px;
  cursor: pointer;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  background: transparent;
  border-radius: 0;
  transition: background 0.2s, color 0.2s;
}
.custom-menu-item.active {
  background: #fff;
  color: #2EA2FA;
  border-radius: 20px;
  font-weight: bold;
}
.custom-menu-item .icon-text-group {
  display: flex;
  align-items: center;
  gap: 4px;
}
.custom-menu-item.active .icon-text-group span {
  color: #2EA2FA;
}
.custom-menu-item.active .sidebar-star svg {
  fill: #2EA2FA !important;
}
.sidebar-logo {
  width: 220px;
  height: 60px;
  border-radius: 8px;
  margin-right: 10px;
  margin-top: 0;
}
.sidebar-title {
  font-size: 18px;
  color: #fff;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.header {
  height: 60px;
  background: #2EA2FA;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 60px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
}
.user-info {
  color: #fff;
}
.content {
  flex: 1;
  background-color: #f5f5f5;
  padding: 30px;
  overflow: auto;
}
</style>
